const zh = {
    scanAddSuccess: '扫描单新增成功',
    scanAddFail: '扫描单新增失败',
    tip: '提示',
    delScanTip1: '你确认要删除这个扫描单吗? 删除后数据不可以恢复',
    scanDelSuccess: '扫描单删除成功',
    addScan: '新增扫描单',
    scanCount: '共扫描{{count}}件商品',
    oprtName: '操作人: {{name}}',
    enterCode: '请输入条形码',
    cancel: '取消',
    confirm: '确认',
    sameCheck: '重复项检查',
    conIn: '确定入库',
    conOut: '确定出库',
    addScanTip:"数据默认以'空格'和'回车'进行分割，并且在输入完成后会将重复条形码进行删除。",
    scanSheet1: '扫描单',
    sameBarcodeTip1: '同一商品中存在条码重复，请修改数据后再次提交。',
    sameBarcodeTip2: '扫描单中存在重复条码，请检查数据再次提交。',
    confirmClearData: '当前页面已有内容，确认清空数据吗？',
    scanSheetNum: '扫描单{{num}}',
    scanSheetCount: '扫描单{{count}}',
    fillBarcodeFirst: '请先填写条码后再新增数据。',
    selProductForBarcode: '商品：',
    selProductForBarcodePl: '请为条形码选择商品',
    clear: '清除',
    addNew: '新增',
    scanSheetData: '扫描单数据',
    addScanMax: '最多只能新增{{num}}条扫描单',
    scanNumExceedMax: '条码数量超过最大限制',
    scanNumExceedMaxTip: '最多只能输入{{num}}个条形码。',
    residueBarcodeNum: '剩余可添加{{residueNum}}个条形码,请对数据进行修改后再次提交.',
    confirmDelBarcodesNum: '确认删除选中的{{delNum}}个条形码吗?',
    delText: '删除',
    saveText: '保存',
    saveAndAdd: '保存并新增',
    addBarcodes: '添加条形码',
    delBarcodes: '删除条形码',
    notFoundBarcodes: '未查询到条形码',
    confirmClearDataTip: '当前页面已有内容未保存，确认删除吗？',
    searchBarcodePlaceholder: '请输入条形码搜索',
    notSelectedBarcode: '当前未勾选删除条形码',
    noDelScanSheet: '仅剩一条数据时为默认数据，不可删除。',
    butDelTooltip: '清空当前商品和条形码数据',
    butSaveTooltip: '保存当前扫描单数据',
    butSaveAndAddTooltip: '保存扫描单数据并添加新的扫描单',
    manufactureBarcode: '批量生成条形码',
    barcodeNotEmpty: '条形码数据不可为空',
    saveScanTip: '请先保存当前扫描单',
    barcodePrefix: '条形码前缀',
    barcodeSuffix: '条形码后缀',
    barcodeStartNum: '条形码起始数字',
    barcodeEndNum: '条形码结束数字',
    barcodeMaxCount: '最大生成数量限制（{{maxCount}}个）',
    generateBarcode: '生成条形码',
    scanDataFillTip: '请将已有扫描单数据进行填写',
    allCheckBarcodes: '全选',
    endLessThanStart: '结束数字不能小于起始数字',
    selectProductTip: '请选择商品',
    barcodeTip: '请填写条形码',
    productAndBarcodeTip: '请选择商品和填写条形码',
    delInInventory: '删除并确定入库',
    delOutInventory: '删除并确定出库',
    selectPl: '请选择',
};

export default zh;